"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));

var _react = _interopRequireDefault(require("react"));

var _login = _interopRequireDefault(require("./src/components/login"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _actions = require("./src/redux/modules/auth/actions");

var _asyncDispatch = require("./src/redux/helpers/asyncDispatch");

var _ref2 =
/*#__PURE__*/
(0, _jsx2["default"])("div", {});

var exposeLoginToGlobalContext = function exposeLoginToGlobalContext(_ref) {
  var open = _ref.open,
      close = _ref.close;
  if (process.browser) window.EmCasaLogin = {
    open: open,
    close: close
  };
  return _ref2;
};

var LoginSaga = function LoginSaga(props) {
  return _react["default"].createElement(_login["default"], props, exposeLoginToGlobalContext);
};

LoginSaga.propTypes = {
  onSuccess: _propTypes["default"].func,
  onError: _propTypes["default"].func
};

var _default = (0, _asyncDispatch.mapAsyncDispatchToProps)({
  submitToken: _actions.CREATORS.submitToken,
  requestToken: _actions.CREATORS.requestToken
})(LoginSaga);

exports["default"] = _default;